import { SpotlightPanel } from '@carouselgg/nexus/spotlight-panel'
import { ArrowRight } from '@carouselgg/nexus/icon'
import { ActionLink } from '../../../components/ActionLink'
import { formatIn } from '../needsYou'
import { dayLabel, timeLabel, type WeekCard } from './homeModel'
import styles from './home.module.css'

type MatchCard = Extract<WeekCard, { kind: 'match' }>

/**
 * The one thing the page is about: your next match.
 *
 * Only ever a match you play. Work for orgs you run is in the to-do list and
 * their panels; putting it here as well would say it twice.
 */
export function UpNext({ card, now, brandColor }: { card: MatchCard; now: Date; brandColor?: string }) {
  const [mine, other] = card.sides
  const when = card.live
    ? 'Live now'
    : card.tbd
      ? 'Time to be confirmed'
      : `${dayLabel(card.at, now)} · ${timeLabel(card.at)}`
  const startsIn = card.at.getTime() - now.getTime()

  return (
    <SpotlightPanel
      aria-label="Up next"
      data-panel="Up next"
      titleSize="4xl"
      brandColor={brandColor}
      logo={mine?.logoUrl ? <img src={mine.logoUrl} alt="" /> : undefined}
      eyebrow={
        <span className={styles.upNextEyebrow}>
          <span className={styles.upNextLabel}>Up next</span>
          {card.live && <span className={styles.liveDot} aria-hidden="true" />}
          {when}
        </span>
      }
      title={
        <>
          {mine?.name ?? 'Your match'}
          {other && (
            <>
              {' '}<span className={styles.vs}>vs</span>{' '}
              <span className={styles.opponent}>{other.name}</span>
            </>
          )}
        </>
      }
      meta={[card.subtitle, card.host, card.game].filter((m): m is string => Boolean(m))}
      figures={mine?.record && other?.record
        ? [
            { label: mine.name, value: mine.record },
            { label: other.name, value: other.record },
          ]
        : undefined}
      aside={!card.live && !card.tbd && startsIn > 0
        ? (
          <dl className={styles.countdown}>
            <dt>Starts in</dt>
            <dd>{formatIn(startsIn)}</dd>
          </dl>
        )
        : undefined}
      actions={
        <ActionLink to={card.to}>
          Match page <ArrowRight size={16} aria-hidden="true" />
        </ActionLink>
      }
    />
  )
}
